import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { IProjectLocation } from '../../interfaces/IProjectLocation';


@Component({
  selector: 'eic-project-locations',
  templateUrl: './project-locations.component.html',
  styleUrl: './project-locations.component.scss'
})
export class ProjectLocationsComponent {
  @Input() projectLocations: IProjectLocation[];   //$: Observable<IProjectLocation[]>;

  searchTerm: string;
  highlightThreshold: number = 15;

  constructor() {
  }


  get locatorPosition(): [number, number] {
    // logic to get the locator position of this project
    const mainLocation =
      this.projectLocations.find(l => l.main === 'main') ?? null;
    
    const coordinates = JSON.parse(mainLocation.geoJsonCoordinates);

    const locatorCoordinates = this.getFeatureLocations(coordinates)[0] ?? null;

    return locatorCoordinates; // London hard-coded for testing;
  }
     

  computePolygonCentroid(coordinates: [number, number][]): [number, number] {
  let area = 0;
  let cx = 0;
  let cy = 0;

  const n = coordinates.length;

  for (let i = 0; i < n - 1; i++) {
    const [x0, y0] = coordinates[i];
    const [x1, y1] = coordinates[i + 1];

    const a = x0 * y1 - x1 * y0;
    area += a;
    cx += (x0 + x1) * a;
    cy += (y0 + y1) * a;
  }

  area *= 0.5;
  cx /= (6 * area);
  cy /= (6 * area);

  return [cx, cy];
}

 getFeatureLocations(featureCollection: GeoJSON.FeatureCollection): [number, number][] {
  return featureCollection.features.map(feature => {
    const geometry = feature.geometry;

    switch (geometry.type) {
      case 'Point':
        return geometry.coordinates as [number, number];

      case 'LineString':
        return geometry.coordinates[0] as [number, number];

      case 'Polygon':
        const outerRing = geometry.coordinates[0]; // first ring is the outer boundary
        return this.computePolygonCentroid(outerRing as [number, number][]);

      default:
        throw new Error(`Unsupported geometry type: ${geometry.type}`);
    }
  });
}
  
    


  // BG 8 July 2025 -  why on earth is this in the Project Locations template?
  // is it a cut/paste error???

  //-- Project Note Highlight ------------------------------------------------
  // Although there are entries in the template, I am not sure 
  // this is valid or needed
  dateDiff(startDate, endDate) {
    return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
  }

  projectCreatedWithinThreshold(dateCreated, dateUpdated, threshold) {
    return (this.dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
  }

  projectUpdatedWithinThreshold(dateUpdated, threshold) {
    return (this.dateDiff(dateUpdated, new Date()) < threshold);
  }

  highlightClass(created, updated) {
    created = new Date(created);
    updated = new Date(updated);

    if (this.projectCreatedWithinThreshold(created, updated, this.highlightThreshold)) return "created";
    if (this.projectUpdatedWithinThreshold(updated, this.highlightThreshold)) return "updated";

    return "";
  }




}
